import React from 'react';
import { HierarchyFolder, TileInfo } from 'app/home/index.functions';
import { UserAuth } from 'store/auth';
import { TileFavorite } from './TileFavorite';
import { Tile4FavoriteData } from 'app/home/index';

export const TileFavoriteLine = function ({
    style,
    tile,
    tileicons,
    userauth,
    setTile4Favorite,
    favorites,
}: {
    style?: any;
    tile: TileInfo;
    tileicons?: { [key: string]: string };
    userauth: UserAuth;
    setTile4Favorite: (data: Tile4FavoriteData | null) => void;
    favorites: HierarchyFolder[];
}) {
    let defaultStyle = {};

    return (
        <TileFavorite
            tile={tile}
            tileicons={tileicons}
            userauth={userauth}
            style={style}
            defaultStyle={defaultStyle}
            setTile4Favorite={setTile4Favorite}
            favorites={favorites}
        />
    );
};
